import gtagActions from './gtag/actions';
import jqueryActions from './jquery/actions';
import bottomlineActions from './bottomline/actions';

const actions = {
  ANALYTICS_INIT: 'ANALYTICS_INIT',
  ANALYTICS_SEND_SCREENVIEW: 'ANALYTICS_SCREENVIEW_EVENT',

  // Do not change the events below - they are being used in custom event analytics hooks
  FIELD_BLUR: 'OAO_FIELD_BLUR',
  FIELD_ERROR: 'OAO_FIELD_ERROR',
  GOOGLE_PLACES_AUTOCOMPLETE: 'OAO_GOOGLE_PLACES_AUTOCOMPLETE',
  GROUP: 'OAO_GROUP',
  GROUP_NAV: 'OAO_GROUP_NAV',
  GROUP_SUBMIT: 'OAO_GROUP_SUBMIT',
  GROUP_SUBMIT_ERROR: 'OAO_GROUP_SUBMIT_ERROR',
  GROUP_SUBMIT_SUCCESS: 'OAO_GROUP_SUBMIT_SUCCESS',
  PAGE: 'OAO_PAGE',
  PAGE_NAV: 'OAO_PAGE_NAV',
  PAGE_SUBMIT: 'OAO_PAGE_SUBMIT',
  PAGE_SUBMIT_ERROR: 'OAO_PAGE_SUBMIT_ERROR',
  PAGE_SUBMIT_SUCCESS: 'OAO_PAGE_SUBMIT_SUCCESS',
  SERVER_ERROR: 'OAO_SERVER_ERROR',
  START: 'OAO_START',
  TIMEOUT: 'OAO_TIMEOUT',
  TIMEOUT_WARNING: 'OAO_TIMEOUT_WARNING',
  TOOLTIP_VIEW: 'OAO_TOOLTIP_VIEW',
  WORKFLOW_END: 'OAO_WORKFLOW_END',

  analyticsInit: () => ({
    type: actions.ANALYTICS_INIT,
  }),
  analyticsSendScreenview: (payload) => ({
    payload,
    type: actions.ANALYTICS_SEND_SCREENVIEW,
  }),

  oaoFieldBlur: (payload) => ({
    payload: {
      eventCategory: 'Action',
      eventLabel: payload,
    },
    type: actions.FIELD_BLUR,
  }),
  oaoFieldError: (payload) => ({
    payload: {
      eventCategory: 'Action',
      eventLabel: payload,
    },
    type: actions.FIELD_ERROR,
  }),
  oaoGooglePlacesAutocomplete: (payload) => ({
    payload: {
      eventCategory: 'Action',
      eventLabel: payload,
    },
    type: actions.GOOGLE_PLACES_AUTOCOMPLETE,
  }),
  oaoGroup: (payload) => ({
    payload: {
      eventCategory: 'View',
      eventLabel: payload,
    },
    type: actions.GROUP,
  }),
  oaoGroupNav: (payload) => ({
    payload: {
      eventCategory: 'Action',
      eventLabel: payload,
    },
    type: actions.GROUP_NAV,
  }),
  oaoGroupSubmit: (payload) => ({
    payload: {
      eventCategory: 'Action',
      eventLabel: payload,
    },
    type: actions.GROUP_SUBMIT,
  }),
  oaoGroupSubmitError: (payload) => ({
    payload: {
      eventCategory: 'Error',
      eventLabel: payload,
    },
    type: actions.GROUP_SUBMIT_ERROR,
  }),
  oaoGroupSubmitSuccess: (payload) => ({
    payload: {
      eventCategory: 'Success',
      eventLabel: payload,
    },
    type: actions.GROUP_SUBMIT_SUCCESS,
  }),
  oaoPage: (payload) => ({
    payload: {
      eventCategory: 'View',
      eventLabel: payload,
    },
    type: actions.PAGE,
  }),
  oaoPageNav: (payload) => ({
    payload: {
      eventCategory: 'Action',
      eventLabel: payload,
    },
    type: actions.PAGE_NAV,
  }),
  oaoPageSubmit: (payload) => ({
    payload: {
      eventCategory: 'Action',
      eventLabel: payload,
    },
    type: actions.PAGE_SUBMIT,
  }),
  oaoPageSubmitError: (payload) => ({
    payload: {
      eventCategory: 'Error',
      eventLabel: payload,
    },
    type: actions.PAGE_SUBMIT_ERROR,
  }),
  oaoPageSubmitSuccess: (payload) => ({
    payload: {
      eventCategory: 'Success',
      eventLabel: payload,
    },
    type: actions.PAGE_SUBMIT_SUCCESS,
  }),
  oaoServerError: (payload) => ({
    payload: {
      eventCategory: 'Action',
      eventLabel: payload,
    },
    type: actions.SERVER_ERROR,
  }),
  oaoStart: (payload) => ({
    payload: {
      eventCategory: 'Action',
      eventLabel: payload,
    },
    type: actions.START,
  }),
  oaoTimeout: (payload) => ({
    payload: {
      eventCategory: 'Action',
      eventLabel: payload,
    },
    type: actions.TIMEOUT,
  }),
  oaoTimeoutWarning: (payload) => ({
    payload: {
      eventCategory: 'Action',
      eventLabel: payload,
    },
    type: actions.TIMEOUT_WARNING,
  }),
  oaoTooltipView: (payload) => ({
    payload: {
      eventCategory: 'Action',
      eventLabel: payload,
    },
    type: actions.TOOLTIP_VIEW,
  }),
  oaoWorkflowEnd: (payload) => ({
    payload: {
      eventCategory: 'Action',
      eventLabel: payload,
    },
    type: actions.WORKFLOW_END,
  }),
};

export default {
  ...actions,
  ...gtagActions,
  ...jqueryActions,
  ...bottomlineActions,
};
